import { createSlice } from "@reduxjs/toolkit";

export const updateTimeSlice = createSlice({
    name: 'updatetime',
    initialState: {
        d506: "2000-01-01"
    },
    reducers: {
        setD506Updatetime: (state, action) => {
            state.d506 = action.payload;
        }
    }
})

export const { setD506Updatetime } = updateTimeSlice.actions;

export const getD506UpdateTime = (state) => state.updatetime.d506;

export default updateTimeSlice.reducer;